import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("SqlInterativoRow")
export class SqlInterativoRow {

  data: string[];

}
